import { lazy, Suspense } from 'react';

const CodeEditor = lazy(() => import('./CodeEditor'));

const LazyCodeEditor = ({ code, readOnly, language = 'mql5' }) => {

  return (
    <Suspense fallback={<div style={{ padding: '16px' }}>Loading code...</div>}>
      <CodeEditor code={code} readOnly={readOnly} language={language} />
    </Suspense>
  );
};

export default LazyCodeEditor;
